var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ListItemText,{attrs:{"value":_setup.getValue,"symbol":_setup.props.symbol,"color":_setup.props.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }